var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EditLayout',{attrs:{"title":"screen.tasks.update.title","breadcrumbs":_vm.breadcrumbs}},[_c('CreateUpdateTask',{ref:"createUpdateTask",attrs:{"formHandler":_vm.formHandler,"btnText":"screen.tasks.update.title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }